import { useBookmarks } from "@/context/BookmarkContext";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { useNavigate } from "react-router-dom";
import { Bookmark, BookmarkCheck } from "lucide-react";
import { toast } from "sonner";

export default function BookmarkButton({ slug, title, variant = "inline" }) {
  const { isBookmarked, toggleBookmark } = useBookmarks();
  const { t, pick } = useLang();
  const { user } = useAuth();
  const { system_messages } = useSettings();
  const navigate = useNavigate();
  const active = isBookmarked(slug);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      const sm = (system_messages || {}).gate_bookmark || {};
      toast(pick(sm.title_hi || "सहेजने हेतु साइन इन करें", sm.title_en || "Sign in to save bookmarks"), {
        description: pick(sm.body_hi || "अपने मंत्र, कथा एवं स्तोत्र सहेजने हेतु निःशुल्क खाता बनाएँ।", sm.body_en || "Create a free account to save and sync your favourites."),
        action: { label: pick("साइन अप", "Sign up"), onClick: () => navigate("/register") },
      });
      return;
    }
    toggleBookmark(slug);
    toast(active ? "Removed from bookmarks" : "Saved to bookmarks", {
      description: title || slug,
    });
  };

  if (variant === "icon") {
    return (
      <button
        data-testid={`bookmark-icon-${slug}`}
        onClick={onClick}
        aria-label={active ? t("bookmarked") : t("bookmark")}
        className={`transition-colors ${active ? "text-saffron" : "text-ink-3 hover:text-saffron"}`}
      >
        {active ? <BookmarkCheck className="h-5 w-5" /> : <Bookmark className="h-5 w-5" />}
      </button>
    );
  }

  return (
    <button
      data-testid={`bookmark-button-${slug}`}
      onClick={onClick}
      aria-pressed={active}
      className={`inline-flex items-center gap-2 rounded-full border px-4 py-2.5 text-sm transition-colors ${
        active
          ? "border-saffron bg-[rgba(199,80,0,0.10)] text-saffron"
          : "border-line text-ink-2 hover:border-saffron hover:text-saffron"
      }`}
    >
      {active ? <BookmarkCheck className="h-4 w-4" /> : <Bookmark className="h-4 w-4" />}
      <span>{active ? (t("bookmarked") || pick("सहेजा गया", "Bookmarked")) : (t("bookmark") || pick("सहेजें", "Bookmark"))}</span>
    </button>
  );
}
